module.exports = {
  branch_name: '车立方店',
  system_name: '青柠檬宿综合管理系统',
  website_title: ' - 青柠檬宿综合管理系统(车立方店)',
  branches: [{
    name: '车立方店',
    url: 'https://apt1.wzxm.site/',
  }, {
    name: '滨海店',
    url: 'https://apt2.wzxm.site/',
  }, {
    name: '柠檬宿酒店',
    url: 'https://apt3.wzxm.site/',
  }],
}



// WEBPACK FOOTER //
// ./config.override.js